'use client'

import { useEffect } from 'react'
import dynamic from 'next/dynamic'

import { useHolidayContext } from '@/src/contexts'
import useHolidaysGtmEvent from '@/src/hooks/analytics/gtm/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import { HOLIDAY_ACTION } from '@/src/utils/analytics/holidays/holidayEvents'
import useHolidayContacted from '@/src/hooks/holidays/useHolidayContacted'

const HolidayPackageDesktopContainer = dynamic(
    () => import(/* webpackChunkName: "HolidayPackageDesktopContainer" */ '@/src/containers/desktop/holidays/package'),
    { ssr: true }
)

const HolidayPackageMobileContainer = dynamic(
    () => import(/* webpackChunkName: "HolidayPackageMobileContainer" */ '@/src/containers/mobile/holidays/package'),
    { ssr: true }
)

const HolidayPackageRootLoader = ({ isMobile, domainCountry }: { isMobile: boolean; domainCountry: string }) => {
    const { packageData } = useHolidayContext()
    const { pushHolidayDetailsPageViewEvent } = useHolidaysGtmEvent()
    const { triggerHolidayPageLoadEvent } = useClevertapForHolidays()
    const { isContacted } = useHolidayContacted()

    // Once per load; a reload of `?contacted=true` reports contacted. The enquiry card re-pushes on success.
    useEffect(() => {
        if (!packageData) return
        pushHolidayDetailsPageViewEvent({
            packageSlug: packageData.slug,
            collectionSlug: packageData.collectionSlug,
            contacted: isContacted
        })
        triggerHolidayPageLoadEvent(HOLIDAY_ACTION.PACKAGE_VIEWED, { contacted: isContacted })
    }, [])

    return isMobile ? (
        <HolidayPackageMobileContainer />
    ) : (
        <HolidayPackageDesktopContainer domainCountry={domainCountry} />
    )
}

export default HolidayPackageRootLoader
